import { computed, inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslateService } from '@ngx-translate/core';
import { AG_GRID_LOCALE_DE } from '@ag-grid-community/locale';
import { map } from 'rxjs';

const AG_GRID_LOCALES: Record<string, Record<string, string>> = {
    en: {},
    de: AG_GRID_LOCALE_DE
};

@Injectable({ providedIn: 'root' })
export class AgGridLocaleService {
    private translateService = inject(TranslateService);

    private currentLang = toSignal(this.translateService.onLangChange.pipe(map(event => event.lang)), {
        initialValue: this.translateService.getCurrentLang() || 'en'
    });

    public readonly localeText = computed<Record<string, string>>(
        () => AG_GRID_LOCALES[this.currentLang()] ?? AG_GRID_LOCALES['en']
    );
}
